// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__10BMg","errors":"Errors_errors__1RTok"};